import { ScheduleDay } from "../../../models";

export const getScheduleDay = (data: any): ScheduleDay => ({
  date: data.date,
  isLocked: data.is_locked,
  publishedAt: data.published_at ?? undefined,
});
